function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3025 0L9.67897 6.12683L13.5847 8.39024L20.3025 4.52683L27.0204 8.39024L30.9261 6.12683L20.3025 0Z",
  fill: "#F0B90B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0204 11.5902L30.9261 13.8537V18.3805L24.2083 22.2439V29.9707L20.3025 32.2341L16.3968 29.9707V22.2439L9.67897 18.3805V13.8537L13.5847 11.5902L20.3025 15.4537L27.0204 11.5902Z",
  fill: "#F0B90B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9261 21.5805V26.1073L27.0204 28.3707V23.8439L30.9261 21.5805Z",
  fill: "#F0B90B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9814 31.5707L33.6992 27.7073V19.9805L37.605 17.7171V29.9707L26.9814 36.0976V31.5707Z",
  fill: "#F0B90B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6992 12.2537L29.7935 9.99025L33.6992 7.72683L37.605 9.99025V14.5171L33.6992 16.7805V12.2537Z",
  fill: "#F0B90B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3968 37.7366V33.2098L20.3025 35.4732L24.2083 33.2098V37.7366L20.3025 40L16.3968 37.7366Z",
  fill: "#F0B90B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5847 28.3707L9.67897 26.1073V21.5805L13.5847 23.8439V28.3707Z",
  fill: "#F0B90B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3025 12.2537L16.3968 9.99025L20.3025 7.72683L24.2083 9.99025L20.3025 12.2537Z",
  fill: "#F0B90B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8116 9.99025L6.90586 12.2537V16.7805L3.00012 14.5171V9.99025L6.90586 7.72683L10.8116 9.99025Z",
  fill: "#F0B90B"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M3.00012 17.7171L6.90586 19.9805V27.7073L13.6237 31.5707V36.0976L3.00012 29.9707V17.7171Z",
  fill: "#F0B90B"
});

var SvgBinance = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBinance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/binance.6c2fcb14.svg";
export { ForwardRef as ReactComponent };